import { api } from "./api";

/**
 * Thin wrapper over the /contacts + /contact-statuses endpoints. Kept as
 * plain module-level functions (no store) since the Contacts pages fetch
 * on mount and don't need cross-page cache invalidation for MVP.
 */
export const contactsApi = {
  listStatuses: (kind) => api.get(`/contact-statuses?kind=${kind}`).then((r) => r.data),
  createStatus: (payload) => api.post("/contact-statuses", payload).then((r) => r.data),
  list: (params = {}) => {
    const q = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== "") q.set(k, v);
    });
    const suffix = q.toString();
    return api.get(`/contacts${suffix ? `?${suffix}` : ""}`).then((r) => r.data);
  },
  get: (id) => api.get(`/contacts/${id}`).then((r) => r.data),
  create: (payload) => api.post("/contacts", payload).then((r) => r.data),
  update: (id, patch) => api.patch(`/contacts/${id}`, patch).then((r) => r.data),
  remove: (id) => api.delete(`/contacts/${id}`).then((r) => r.data),
};
